import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useShopPath } from '@/hooks/useShopPath';

/**
 * Returns a `goBack` callback that navigates to the previous page when
 * in-app history exists, or falls back to `fallbackPath` (shop-scoped)
 * when the user arrived via a direct link / refresh / external bookmark.
 *
 * React Router stores a numeric `idx` on `window.history.state` — 0
 * means this is the first entry in the session, so there's nothing to
 * go back to.
 */
export function useGoBack(fallbackPath) {
	const navigate = useNavigate();
	const { shopPath } = useShopPath();

	return useCallback(() => {
		const hasHistory = window.history.state?.idx > 0;
		if (hasHistory) {
			navigate(-1);
		} else {
			navigate(shopPath(fallbackPath), { replace: true });
		}
	}, [navigate, shopPath, fallbackPath]);
}
